import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = banners.length;

  const goTo = useCallback((idx: number) => {
    setCurrent(((idx % total) + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo(current + 1);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="推荐漫画轮播">
      {banners.map((banner, idx) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={banner.bgImage}
            alt={banner.title}
            className="w-full h-full object-cover object-top"
            title={`${banner.title} - 香香漫画推荐`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-background-50"></div>
          <div className="absolute inset-0 flex items-end pb-12 md:pb-20">
            <div className="w-full px-4 md:px-6 mx-auto">
              <div className="max-w-3xl">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs font-medium mb-3">
                  {banner.subtitle}
                </span>
                <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 mb-3 leading-tight">
                  {banner.title}
                </h2>
                <p className="text-foreground-600 text-sm md:text-base mb-5 max-w-lg">
                  {banner.description}
                </p>
                <Link
                  to={`/comic/${banner.comicId}`}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  立即阅读
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 text-foreground-950 flex items-center justify-center transition-colors cursor-pointer"
        onClick={() => goTo(current - 1)}
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 text-foreground-950 flex items-center justify-center transition-colors cursor-pointer"
        onClick={() => goTo(current + 1)}
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>

      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {banners.map((_, idx) => (
          <button
            key={idx}
            onClick={() => goTo(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
            aria-label={`切换到第${idx + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}